import { render, staticRenderFns } from "./ViewNew.vue?vue&type=template&id=15d48758"
import script from "./ViewNew.vue?vue&type=script&lang=ts"
export * from "./ViewNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d48758')) {
      api.createRecord('15d48758', component.options)
    } else {
      api.reload('15d48758', component.options)
    }
    module.hot.accept("./ViewNew.vue?vue&type=template&id=15d48758", function () {
      api.rerender('15d48758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/browse/ViewNew.vue"
export default component.exports